var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPresentation = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 3.75C3 3.33579 2.66421 3 2.25 3C1.83579 3 1.5 3.33579 1.5 3.75V12C1.5 13.6569 2.84315 15 4.5 15H19.5C21.1569 15 22.5 13.6569 22.5 12V3.75C22.5 3.33579 22.1642 3 21.75 3C21.3358 3 21 3.33579 21 3.75V12C21 12.8284 20.3284 13.5 19.5 13.5H4.5C3.67157 13.5 3 12.8284 3 12V3.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.75C0 0.335786 0.335786 0 0.75 0H23.25C23.6642 0 24 0.335786 24 0.75C24 1.16421 23.6642 1.5 23.25 1.5H0.75C0.335786 1.5 0 1.16421 0 0.75Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 15H12.75V18L15.0936 21.5154C15.3742 21.9363 15.0725 22.5 14.5667 22.5V22.5C14.3673 22.5 14.1796 22.4061 14.06 22.2467L12 19.5L9.93999 22.2467C9.82039 22.4061 9.63268 22.5 9.43335 22.5V22.5C8.92753 22.5 8.62582 21.9363 8.9064 21.5154L11.25 18V15Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPresentation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/presentation.ae5cf383fd1f3c9b1a2942ed8785f8c8.svg";